import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { applySvgDimensions, sanitizeSvg } from '@shared/helpers/sanitize-svg';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MixedObject } from '@core/interfaces/mixed-object';
import { Block } from '@core/models/block/block.model';
import { isValueGradient } from '@shared/helpers';

@Component({
  selector: '[app-svg-block]',
  templateUrl: './svg-block.component.html',
  styleUrls: ['./svg-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SvgBlockComponent implements OnInit {
  @Input() isHovered: boolean;
  @Input() item: Block;
  @Input() blockStyles: MixedObject;
  svgContent: SafeHtml = '';
  shouldUseCustomStyle = true;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.getSvg();
  }

  getSvgStyle() {
    if (!this.shouldUseCustomStyle) {
      return {};
    }
    const isScrolled = document.body.classList.contains('scrolled');
    const styles = this.blockStyles;
    let directStyles = {...styles.basic};
    if (isScrolled) {
      directStyles = {...directStyles, ...styles.scrolled};
    }
    if (this.isHovered) {
      directStyles = {...directStyles, ...styles.hover};
    }

    const svgMaskStyle = {
      '-webkit-mask': `url(${this.item.media?.urls.full}) no-repeat center`,
      mask: `url(${this.item.media?.urls.full}) no-repeat center`,
      '-webkit-mask-size': 'contain',
      maskSize: 'contain',
    };
    let imageStyle: MixedObject;

    if (directStyles.color) {
      imageStyle = {
        backgroundColor: directStyles.color,
        ...svgMaskStyle,
      };
    } else if (isValueGradient(directStyles.backgroundImage)) {
      imageStyle = {
        backgroundImage: directStyles.backgroundImage,
        ...svgMaskStyle,
      };
    } else {
      imageStyle = {
        background: `url(${this.item.media?.urls.full}) no-repeat center`,
        backgroundSize: '100%',
      };
    }


    return {
      aspectRatio: directStyles.aspectRatio,
      width: directStyles.width,
      height: directStyles.height,
      ...imageStyle,
    };
  }

  private getSvg() {
    fetch(this.item.media?.urls.download || this.item.media?.urls.full)
      .then(res => res.text())
      .then(str => {
        // AT-9147: dawny filtr rozcinał treść na dokładnym, małymi literami `<script>`
        // bez atrybutów i w ogóle nie ruszał atrybutów zdarzeń, więc `<svg onload=…>`
        // przechodził. SVG to treść CMS najemcy, a wykonuje się u każdego odwiedzającego.
        const zawieraSkrypt = /<script[\s>]/i.test(str);
        str = sanitizeSvg(str);

        if (!str) {
          return;
        }

        if (zawieraSkrypt) {
          this.shouldUseCustomStyle = false;
        }

        str = str.replace(/width="[^"]*"/, ''); // Usunięcie width
        str = str.replace(/height="[^"]*"/, ''); // Usunięcie height

        // Wymiary dokładamy po sanityzacji, więc przechodzą własną walidację formatu.
        const {width, height, minHeight} = this.blockStyles.basic;
        str = applySvgDimensions(str, {width, height: height || minHeight});

        if (str.includes(':hover')) {
          this.shouldUseCustomStyle = false;
        }
        if (!this.shouldUseCustomStyle) {
          this.svgContent = this.sanitizer.bypassSecurityTrustHtml(str);
        }
      });
  }
}
